import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./login.scss";

const OtpInput = ({ otpValue, onOtpChange, onComplete, inputRef }) => {
  const inputsRef = useRef([]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otpValue];
    newOtp[index] = element.value;

    onOtpChange(newOtp.join(""));

    if (element.nextSibling) {
      element.nextSibling.focus();
    }

    if (newOtp.join("").length === 4) {
      onComplete();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.keyCode === 8 && !otpValue[index] && index !== 0) {
      const newOtp = [...otpValue];
      newOtp[index - 1] = "";
      onOtpChange(newOtp.join(""));

      const previousSibling = inputsRef.current[index - 1];
      if (previousSibling) {
        previousSibling.focus();
      }
    }
  };

  useEffect(() => {
    if (otpValue.every((val) => val === "")) {
      if (inputsRef.current[0]) {
        inputsRef.current[0].focus();
      }
    }
  }, [otpValue]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  return (
    <div className="otp-input-container">
      <div className="otp-inner-container">
        <label className="otp-label">Enter OTP :</label>
        {Array.from({ length: 4 }).map((_, index) => (
          <input
            key={index}
            type="text"
            className="otp-input"
            maxLength="1"
            value={otpValue[index] || ""}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(ref) => (inputsRef.current[index] = ref)}
          />
        ))}
      </div>
    </div>
  );
};

OtpInput.propTypes = {
  otpValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  onOtpChange: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  inputRef: PropTypes.object,
};

export default OtpInput;
